/**
 * OUR FOUR SEVERITIES, THE ONE PLACE THEIR WORDS LIVE (2026-10-21): Critical, Major, Minor and Unknown,
 * the API's own scale (`severityOf`, its alarm service: the vendor's level 6 and up, 3 and up, 1 and
 * up, and none). Every list of alarms says them in these words and draws them with `SeverityMark`: the
 * header's counters, the site's Alarms tab, the board, an alarm's page, the bell and the toasts.
 *
 * Never "Warning": the console has no such severity, and the fourth is an alarm that arrived with no
 * level, which is not a mild one. Which severity a row RANKS by is `effectiveSeverity` (`alarm-words.ts`).
 */
import type { Severity } from '@/lib/api/types';

export const SEVERITIES: ReadonlyArray<readonly [Severity, string]> = [
  ['critical', 'Critical'],
  ['major', 'Major'],
  ['minor', 'Minor'],
  ['unknown', 'Unknown'],
];

/** A severity in one letter, for a phone's counters (2026-10-21); the word stays the chip's title and aria-label. */
export const SEVERITY_LETTER: Readonly<Record<string, string>> = { critical: 'C', major: 'M', minor: 'm', unknown: 'U' };

/** Worst first. */
export const SEVERITY_RANK: Readonly<Record<string, number>> = { critical: 0, major: 1, minor: 2, unknown: 3 };

/** The word for a severity; anything not on our scale is Unknown. */
export function severityWord(s: string): string {
  return SEVERITIES.find(([k]) => k === s.toLowerCase())?.[1] ?? 'Unknown';
}
